<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post19-terminals-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post19-terminals-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.859375;"
    data-aspect-ratio="0.859"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post19-terminals-xs-img"
      class="g-post19-terminals-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-terminals-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.2503%;margin-top:-8.1px;left:2.1484%;width:207px;"
    >
      <p class="g-pstyle1">5 mb/d (million barrels per day)</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.3128%;margin-top:-8.1px;left:2.1484%;width:30px;"
    >
      <p class="g-pstyle1">4</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.3184%;margin-top:-16.6px;left:79.0557%;width:84px;"
    >
      <p class="g-pstyle2">Red Sea</p>
      <p class="g-pstyle2">terminals</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.9065%;margin-top:-8.1px;left:7.02%;width:74px;"
    >
      <p class="g-pstyle3">Juaymah</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.3753%;margin-top:-8.1px;left:2.1484%;width:29px;"
    >
      <p class="g-pstyle1">3</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.7663%;margin-top:-16.6px;left:44.7806%;width:84px;"
    >
      <p class="g-pstyle4">Gulf</p>
      <p class="g-pstyle4">terminals</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:60.1774%;margin-top:-8.1px;left:2.1484%;width:29px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.0836%;margin-top:-8.1px;left:7.02%;width:87px;"
    >
      <p class="g-pstyle3">Ras Tanura</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.9794%;margin-top:-8.1px;left:2.1484%;width:27px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.3232%;margin-top:-8.1px;left:7.02%;width:64px;"
    >
      <p class="g-pstyle5">Muajjiz</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.9586%;margin-top:-8.1px;left:7.02%;width:59px;"
    >
      <p class="g-pstyle5">Yanbu</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.219%;margin-top:-8.1px;left:2.1484%;width:30px;"
    >
      <p class="g-pstyle1">0</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:8.6688%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle6">Jan 6</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:26.4091%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle6">Jan 20</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:43.6373%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle6">Feb 3</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:61.4548%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle6">Feb 17</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:76.8732%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle6">March 3</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8436%;margin-top:-8px;left:92.6117%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">March 17</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.4013%;margin-top:-15.6px;left:74.0421%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle0">War outbreak</p>
      <p class="g-pstyle0">Feb 28</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post19-terminals-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.64516129032258;"
    data-aspect-ratio="1.645"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post19-terminals-sm-img"
      class="g-post19-terminals-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-terminals-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:17.9294%;margin-top:-8.6px;left:0.3897%;width:207px;"
    >
      <p class="g-pstyle1">5 mb/d (million barrels per day)</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.4533%;margin-top:-18.7px;left:84.7032%;width:92px;"
    >
      <p class="g-pstyle2">Red Sea</p>
      <p class="g-pstyle2">terminals</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.4778%;margin-top:-8.6px;left:0.3897%;width:30px;"
    >
      <p class="g-pstyle1">4</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.1874%;margin-top:-8.6px;left:5.3742%;width:74px;"
    >
      <p class="g-pstyle3">Juaymah</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.6713%;margin-top:-8.6px;left:0.3897%;width:29px;"
    >
      <p class="g-pstyle1">3</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.4211%;margin-top:-18.7px;left:52.3439%;width:92px;"
    >
      <p class="g-pstyle4">Gulf</p>
      <p class="g-pstyle4">terminals</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.8649%;margin-top:-8.6px;left:0.3897%;width:29px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.0584%;margin-top:-8.6px;left:5.3742%;width:87px;"
    >
      <p class="g-pstyle3">Ras Tanura</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.0584%;margin-top:-8.6px;left:0.3897%;width:27px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.639%;margin-top:-8.6px;left:5.3742%;width:64px;"
    >
      <p class="g-pstyle5">Muajjiz</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.639%;margin-top:-8.6px;left:5.3742%;width:59px;"
    >
      <p class="g-pstyle5">Yanbu</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.639%;margin-top:-8.6px;left:0.3897%;width:30px;"
    >
      <p class="g-pstyle1">0</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:6.8233%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle6">Jan 6</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:25.0424%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle6">Jan 20</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:42.6011%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle6">Feb 3</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:60.7987%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle6">Feb 17</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:79.3807%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">March 3</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.639%;margin-top:-8.6px;left:94.676%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle6">March 17</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.3621%;margin-top:-16.6px;left:73.8779%;margin-left:-53px;width:106px;"
    >
      <p class="g-pstyle0">War outbreak</p>
      <p class="g-pstyle0">Feb 28</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post19-terminals-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 2.03703703703703;"
    data-aspect-ratio="2.037"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post19-terminals-md-img"
      class="g-post19-terminals-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-terminals-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.6979%;margin-top:-8.6px;left:0.7557%;width:207px;"
    >
      <p class="g-pstyle1">5 mb/d (million barrels per day)</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.6608%;margin-top:-8.6px;left:0.7557%;width:30px;"
    >
      <p class="g-pstyle1">4</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.0202%;margin-top:-9.7px;left:78.4452%;width:157px;"
    >
      <p class="g-pstyle2">Red Sea terminals</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.9942%;margin-top:-8.6px;left:5.7555%;width:74px;"
    >
      <p class="g-pstyle3">Juaymah</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.2411%;margin-top:-8.6px;left:0.7557%;width:29px;"
    >
      <p class="g-pstyle1">3</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.7486%;margin-top:-9.7px;left:50.1166%;width:127px;"
    >
      <p class="g-pstyle4">Gulf terminals</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.8213%;margin-top:-8.6px;left:0.7557%;width:29px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.8337%;margin-top:-8.6px;left:5.7555%;width:87px;"
    >
      <p class="g-pstyle3">Ras Tanura</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.4016%;margin-top:-8.6px;left:0.7557%;width:27px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.8707%;margin-top:-8.6px;left:5.7555%;width:64px;"
    >
      <p class="g-pstyle5">Muajjiz</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.4386%;margin-top:-8.6px;left:5.7555%;width:59px;"
    >
      <p class="g-pstyle5">Yanbu</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.4386%;margin-top:-8.6px;left:0.7557%;width:30px;"
    >
      <p class="g-pstyle1">0</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:7.4016%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle6">Jan 6</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:25.6774%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle6">Jan 20</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:43.2943%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle6">Feb 3</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:61.5535%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle6">Feb 17</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:80.1841%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle6">March 3</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5497%;margin-top:-8.6px;left:95.5319%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle6">March 17</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.6736%;margin-top:-16.6px;left:74.4804%;margin-left:-53px;width:106px;"
    >
      <p class="g-pstyle0">War outbreak</p>
      <p class="g-pstyle0">Feb 28</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post19-terminals-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post19-terminals-lg-img"
      class="g-post19-terminals-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-terminals-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post19-terminals-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post19-terminals-xl-img"
      class="g-post19-terminals-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-terminals-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-17 16:56 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-17 16:56 -->
<!-- ai file: post19-terminals.ai -->
<style lang="scss">
  #g-post19-terminals-box {
    container-type: inline-size;
    container-name: g-post19-terminals-box;
  }
  #g-post19-terminals-box,
  #g-post19-terminals-box .g-artboard {
    margin: 0 auto;
  }
  #g-post19-terminals-box p {
    margin: 0;
  }
  #g-post19-terminals-box .g-aiAbs {
    position: absolute;
  }
  #g-post19-terminals-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post19-terminals-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post19-terminals-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-terminals-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-terminals-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post19-terminals-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post19-terminals-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post19-terminals-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post19-terminals-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post19-terminals-xl {
        display: block !important;
      }
    }
  }
  #g-post19-terminals-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-terminals-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-terminals-xs .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    text-align: center;
  }
  #g-post19-terminals-xs .g-pstyle1 {
    font-weight: 400;
    height: 15px;
  }
  #g-post19-terminals-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-xs .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-xs .g-pstyle5 {
    font-weight: 400;
    height: 15px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-xs .g-pstyle6 {
    font-weight: 400;
    height: 15px;
    font-size: 13px;
    text-align: center;
  }
  #g-post19-terminals-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-terminals-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-terminals-sm .g-pstyle0 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
    text-align: center;
  }
  #g-post19-terminals-sm .g-pstyle1 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-terminals-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 17px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-sm .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 17px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-sm .g-pstyle5 {
    font-weight: 400;
    height: 16px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-sm .g-pstyle6 {
    font-weight: 400;
    height: 16px;
    text-align: center;
  }
  #g-post19-terminals-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-terminals-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-terminals-md .g-pstyle0 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
    text-align: center;
  }
  #g-post19-terminals-md .g-pstyle1 {
    font-weight: 400;
    height: 16px;
  }
  #g-post19-terminals-md .g-pstyle2 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 17px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-md .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-md .g-pstyle4 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 17px;
    color: rgb(55, 138, 221);
  }
  #g-post19-terminals-md .g-pstyle5 {
    font-weight: 400;
    height: 16px;
    color: rgb(216, 90, 48);
  }
  #g-post19-terminals-md .g-pstyle6 {
    font-weight: 400;
    height: 16px;
    text-align: center;
  }
  #g-post19-terminals-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-terminals-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-terminals-lg .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-terminals-lg .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-terminals-lg .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-post19-terminals-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-terminals-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-terminals-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-terminals-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-terminals-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
